import React from "react";

function SocialIcon({ name }) {
    if (name === "x") {
        return (
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
            >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
        );
    }
    if (name === "instagram") {
        return (
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
            </svg>
        );
    }
    return null;
}

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer
            id="contact"
            data-testid="site-footer"
            className="relative border-t border-[var(--tb-border)] mt-10"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 mb-16">
                    <div className="md:col-span-7">
                        <span className="tb-overline">Pre-flight every play</span>
                        <h3
                            data-testid="footer-headline"
                            className="font-display text-white text-3xl md:text-5xl font-extrabold mt-5 leading-[1.05] tracking-tight max-w-xl"
                        >
                            Audit with Tiltbox.
                            <br />
                            <span style={{ color: "var(--tb-gold)" }}>
                                Bet with discipline.
                            </span>
                        </h3>
                        <p className="text-[var(--tb-text-body)] mt-5 max-w-md text-[15px] leading-relaxed">
                            Tiltbox is a sports betting audit and analytics
                            platform built for bettors who treat their bankroll
                            like capital, not chips.
                        </p>
                    </div>

                    <div className="md:col-span-5 flex flex-col md:items-end">
                        <span className="tb-overline mb-5">Follow</span>
                        <div className="flex gap-3">
                            <span
                                data-testid="social-x"
                                aria-label="X (inactive)"
                                aria-disabled="true"
                                className="w-11 h-11 rounded-full border border-[var(--tb-border)] flex items-center justify-center text-[var(--tb-text-dim)] select-none cursor-default"
                            >
                                <SocialIcon name="x" />
                            </span>
                            <a
                                href="https://instagram.com/tiltboxapp"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="social-instagram"
                                aria-label="Tiltbox on Instagram"
                                className="w-11 h-11 rounded-full border border-[var(--tb-border)] flex items-center justify-center text-[var(--tb-text-body)] hover:border-[var(--tb-gold)] hover:text-[var(--tb-gold)] transition-colors"
                            >
                                <SocialIcon name="instagram" />
                            </a>
                        </div>

                        <div className="mt-10 md:text-right max-w-sm">
                            <p className="text-[var(--tb-text-dim)] text-[13px] leading-relaxed">
                                Tiltbox is a tool for disciplined bettors. It
                                does not place wagers, hold funds, or guarantee
                                outcomes. Bet responsibly.
                            </p>
                        </div>
                    </div>
                </div>

                <div
                    aria-hidden="true"
                    data-testid="footer-watermark"
                    className="tb-watermark text-[22vw] md:text-[18vw] text-center -mb-6 select-none overflow-hidden"
                >
                    TILTBOX
                </div>

                <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 border-t border-[var(--tb-border)] mt-4">
                    <p
                        data-testid="footer-copy"
                        className="text-[12px] text-[var(--tb-text-dim)] tracking-wide"
                    >
                        © {year} Tiltbox. All rights reserved.
                    </p>
                    <p
                        data-testid="footer-tag"
                        className="text-[12px] text-[var(--tb-text-dim)] tracking-[0.2em] uppercase"
                    >
                        Audit · Discipline · Edge
                    </p>
                </div>
            </div>
        </footer>
    );
}
